// packages/chatbot/src/utils/constants.ts

// Single source of truth for the synthetic "new chat" placeholder id.
// Used across Sidebar/Tabs and the controller.
export const NEW_CHAT_ID = 'new-chat-placeholder';
